import { useNavigate, useParams } from 'react-router-dom'
import { useAffiliations } from './useAffiliations'

const useAffiliation = () => {
  const { tenantUrlSlug, affiliationUrlSlug } = useParams()
  const { affiliations } = useAffiliations()
  const navigate = useNavigate()

  if (affiliations?.length && !affiliationUrlSlug) {
    navigate(`/${tenantUrlSlug}/${affiliations[0].urlSlug}`)
  }

  const affiliation = affiliations?.find(
    (it) => it.urlSlug.toLowerCase() === affiliationUrlSlug?.toLowerCase()
  )

  return { affiliation }
}

export { useAffiliation }
